import { jwtDecode } from 'jwt-decode';

export interface JwtAgentPayload {
  exp: number;
  agent_code: string;
  name: string;
}

/**
 * Validates a JWT token using jwt-decode and checks its expiration
 * @param token JWT token string
 * @returns boolean indicating if the token is valid and not expired
 */
export const isValidJwtToken = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtAgentPayload>(token);
    const currentTimestamp = Math.floor(Date.now() / 1000);

    return decoded.exp > currentTimestamp;
  } catch {
    // Fallback in case the JWT is malformed
    return false;
  }
};
